import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useStudentPortalContext } from "@/contexts/StudentPortalContext";
import { api } from "@/lib/api";
import { ClipboardList, FileText } from "lucide-react";
import { PortalEmpty, PortalLoading, PortalPageHeader } from "./StudentPortalParts";

const STATE = {
  AVAILABLE: ["Disponível", "doxa-badge-success", "Iniciar"],
  IN_PROGRESS: ["Em andamento", "doxa-badge-warning", "Continuar"],
  NOT_OPEN: ["Ainda não aberta", "doxa-badge-neutral", null],
  CLOSED: ["Encerrada", "doxa-badge-neutral", null],
  AWAITING_GRADING: ["Aguardando correção", "doxa-badge-warning", "Ver"],
  GRADED: ["Corrigida", "doxa-badge-success", "Ver resultado"],
  SUBMITTED: ["Enviada", "doxa-badge-neutral", "Ver resultado"],
};

export default function StudentActivities() {
  const { loading: contextLoading, selectedClassId } = useStudentPortalContext();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!selectedClassId) { setData(null); setLoading(false); return; }
    let alive = true;
    setLoading(true);
    api.get("/student/portal/activities", { params: { class_group_id: selectedClassId } })
      .then(({ data: next }) => { if (alive) setData(next); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [selectedClassId]);

  if (contextLoading || loading) return <PortalLoading />;
  const evaluations = data?.evaluations || [];
  const tasks = data?.tasks || [];

  return <div data-testid="student-activities-v2">
    <PortalPageHeader eyebrow="O que fazer" title="Atividades" description="Avaliações e tarefas em um só lugar, com estado e prazo claros." />
    <section className="mb-8">
      <h2 className="font-display text-lg font-bold mb-3 inline-flex items-center gap-2"><FileText className="w-4 h-4 text-[#F75A1B]" /> Avaliações</h2>
      {evaluations.length ? <div className="grid md:grid-cols-2 gap-3">{evaluations.map((ev) => { const st = STATE[ev.state] || STATE.SUBMITTED; return <article key={ev.id} className="doxa-card p-5"><h3 className="font-display font-bold">{ev.title}</h3><span className={`doxa-badge ${st[1]} mt-2 inline-block`}>{st[0]}</span>{ev.description && <p className="text-sm text-[#6B655E] mt-3">{ev.description}</p>}{st[2] && <button onClick={() => navigate(`/aluno/avaliacoes/${ev.id}`)} className="doxa-btn-primary mt-4 w-full py-2.5 text-sm">{st[2]}</button>}</article>; })}</div> : <PortalEmpty icon={FileText} title="Nenhuma avaliação disponível" />}
    </section>
    <section>
      <h2 className="font-display text-lg font-bold mb-3 inline-flex items-center gap-2"><ClipboardList className="w-4 h-4 text-[#F75A1B]" /> Tarefas</h2>
      {tasks.length ? <div className="grid md:grid-cols-2 gap-3">{tasks.map((task) => <article key={task.id} className="doxa-card p-5"><h3 className="font-semibold">{task.title}</h3>{task.description && <p className="text-sm text-[#6B655E] mt-2 whitespace-pre-wrap">{task.description}</p>}{task.due_date && <p className="text-xs font-medium text-[#F75A1B] mt-3">Entrega: {task.due_date}</p>}</article>)}</div> : <PortalEmpty icon={ClipboardList} title="Nenhuma tarefa" />}
    </section>
  </div>;
}
